<div class="main_container">
  <ps-ui-header-service-account (openServiceAccountModal)="selectBuyer($event)">
  </ps-ui-header-service-account>
  <header class="dashboard-header">
    <div class="col-auto dash-logo-section">
      <img
        class="img-responsive"
        src="../../../../assets/image/logo-without-name.png"
        alt="Logo"
        title=""
        (click)="goToDashboard(true)"
      />
      <p><a href="tel:+877865-PURE">(877) 865-PURE</a></p>
    </div>
    <div class="col-xs-12 col-sm-8 col-md-10 header-div">
      <ps-ui-create-survey-data
        (closeSurvey)="goToDashboard($event)"
        [isNewSurvey]="isNewSurvey"
        [isLaunchSurvey]="isLaunchSurvey"
        [isRecontactSurvey]="isRecontactSurvey"
      ></ps-ui-create-survey-data>
    </div>
    <div class="clearfix"></div>
  </header>
</div>
